module.exports = __webpack_public_path__ + "img/fi_get.ad3e312.png";